export default __webpack_public_path__ + "static/media/gowebapp.0a8b97fe.png";